'use client'

import React from 'react'

// -- Stat pill (same pattern as CashFlowDetailBar) --

export function Stat({
  label,
  children,
  color,
  title,
}: {
  label: string
  children: React.ReactNode
  color?: string
  title?: string
}) {
  return (
    <span
      className="inline-flex items-baseline gap-1 whitespace-nowrap rounded-md bg-primary-50 px-1.5 py-0.5 dark:bg-primary-800/50"
      title={title}
    >
      <span className="text-xs font-medium uppercase tracking-wider text-primary-400 dark:text-primary-500">
        {label}
      </span>
      <span
        className="text-xs font-semibold"
        style={color ? { color } : undefined}
      >
        {children}
      </span>
    </span>
  )
}

// -- Shimmer skeleton for Tier 2 data --

export function DetailShimmer() {
  return (
    <div className="space-y-3 animate-pulse">
      <div className="h-3 w-3/4 rounded bg-primary-100 dark:bg-primary-800" />
      <div className="h-3 w-1/2 rounded bg-primary-100 dark:bg-primary-800" />
      <div className="h-3 w-2/3 rounded bg-primary-100 dark:bg-primary-800" />
      <div className="h-3 w-1/3 rounded bg-primary-100 dark:bg-primary-800" />
    </div>
  )
}

// -- Detail row for Tier 2 fields --

export function DetailRow({
  label,
  value,
}: {
  label: string
  value: React.ReactNode
}) {
  if (!value) return null
  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-xs font-medium uppercase tracking-wider text-primary-400 dark:text-primary-500">
        {label}
      </span>
      <span className="text-xs text-primary-700 dark:text-primary-200">
        {value}
      </span>
    </div>
  )
}
